import React from "react";
import classes from "./TextInput.module.css";

const TextInput = ({ label, value, onChange, placeholder, maxLength, showCharCounter, charCounterSuffix, error }) => {

    const handleChange = (e) => {
        if (maxLength && e.target.value.length > maxLength) return;
        onChange(e.target.value);
    };

    return (
        <div className={classes.Field}>
            {label && <label className={classes.Label}>{label}</label>}
            <input
                className={`${classes.Input} ${error ? classes.InputError : ""}`}
                type="text"
                value={value}
                onChange={handleChange}
                placeholder={placeholder}
                maxLength={maxLength}
            />
            {error && <span className={classes.ErrorText}>{error}</span>}
            {showCharCounter && maxLength && (
                <span className={classes.CharCounter}>
                    {value.length}/{maxLength}{charCounterSuffix ? ` ${charCounterSuffix}` : ""}
                </span>
            )}
        </div>
    );
};

export default TextInput;
